import { AgGridReact } from "ag-grid-react";
import { makeStyles } from "@mui/styles";
import React, { useCallback } from "react";
import Paper from "@mui/material/Paper";

const useStyles = makeStyles(() => ({
    root: {
        "& .ag-header-cell": {
            backgroundColor: "#FAFAFA !important",
            color: "red !important"
        },
        "& .ag-header-cell-label": {
            color: "#32363A !important",
            fontWeight: "600 !important"
        },
        "& .centered-header .ag-header-cell-label": {
            justifyContent: "center !important",
            textAlign: "center !important"
        }
    }
}));

const defaultColDef = {
    flex: 1,
    sortable: true,
    resizable: true
};

export default function DGridAg(props) {
    const { rowData, columnDefs, header, height = 500, ...rest } = props;

    const getRowStyle = useCallback((params) => {
        if (params.node.rowIndex % 2 === 0) {
            return {
                background: "#FFFFFF"
            };
        }
    }, []);

    const classes = useStyles();

    return (
        <Paper variant="outlined">
            <div
                style={{
                    width: "100%",
                    height
                }}
                className={`${classes.root} ag-theme-alpine`}
            >
                {header}

                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    getRowStyle={getRowStyle}
                    defaultColDef={defaultColDef}
                    {...rest}
                />
            </div>
        </Paper>
    );
}
